import { render } from "./GeneralBalance.vue?vue&type=template&id=735919de&scoped=true"
import script from "./GeneralBalance.vue?vue&type=script&lang=js"
export * from "./GeneralBalance.vue?vue&type=script&lang=js"

import "./GeneralBalance.vue?vue&type=style&index=0&id=735919de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735919de"]])

export default __exports__